import React from 'react';
import { ThemeProvider } from 'styled-components';
import { theme } from '../theme/aikya';

import { Header }  from './Header';
import { FramesSection } from './FramesSection';
import { PageWrapper } from './PageWrapper';
import { FooterSection } from './FooterSection';

export class FramesPage extends React.Component {
    render() {
        return (
			<ThemeProvider theme={theme}>
				<PageWrapper>
					<Header />
					<FramesSection />
				</PageWrapper>
				<FooterSection />
			</ThemeProvider>
		);
	}
}